export default __webpack_public_path__ + "static/media/icon-backward-15.17e2a384.svg";